// src/components/common/StatusBadge.tsx
import React from 'react';

// ── Presets ───────────────────────────────────────────────────────────────────
const PRESETS = {
   rich:     'bg-yellow-900/50 border-yellow-700 text-yellow-300',
   middle:   'bg-blue-900/50   border-blue-700   text-blue-300',
   poor:     'bg-gray-700      border-gray-600   text-gray-300',
   trading:  'bg-purple-900/50 border-purple-700 text-purple-300',
   oil:      'bg-amber-900/50  border-amber-700  text-amber-300',
   minerals: 'bg-violet-900/50 border-violet-700 text-violet-300',
   forest:   'bg-emerald-900/50 border-emerald-700 text-emerald-300',
   water:    'bg-sky-900/50    border-sky-700    text-sky-300',
   gas:      'bg-orange-900/50 border-orange-700 text-orange-300',
   generic:  'bg-gray-800      border-gray-600   text-gray-400',
} as const;

export type BadgePreset = keyof typeof PRESETS;

interface StatusBadgeProps {
   /** Use a built-in preset key */
   preset?: BadgePreset;
   /** Override with a raw Tailwind class string */
   className?: string;
   /** When provided renders as a button */
   onClick?: () => void;
   /** Highlights the badge as selected when true */
   active?: boolean;
   children: React.ReactNode;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ preset, className, onClick, active, children }) => {
   const base = className ?? (preset ? PRESETS[preset] : PRESETS.generic);
   const cls = `inline-flex items-center gap-1 px-2 py-0.5 rounded-md border text-xs font-medium transition-all
      ${base}
      ${onClick ? 'cursor-pointer' : ''}
      ${active === false ? 'opacity-40 hover:opacity-70' : ''}
      ${active === true  ? 'ring-1 ring-white/40 brightness-150 shadow-sm' : ''}`;
   
   if (onClick) {
      return <button onClick={onClick} className={cls}>{children}</button>;
   }
   return <span className={cls}>{children}</span>;
};

export default StatusBadge;
